var React = require('react');

function Soundcloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,0a6.57,6.57,0,0,0-3,.75A6.69,6.69,0,0,0,12.6,2.81V15H25.5a4.5,4.5,0,0,0,0-9,5.53,5.53,0,0,0-.9.11A6.65,6.65,0,0,0,18,0ZM10.2,3A8.11,8.11,0,0,0,9,3.11V15h1.2Zm.6,0V15H12V3.3A6.2,6.2,0,0,0,10.8,3Zm-2.4.3a6.72,6.72,0,0,0-1.2.6V15H8.4ZM6.6,4.39A5,5,0,0,0,5.4,6V15H6.6ZM3.9,6.6a1,1,0,0,0-.3.05V15a2.43,2.43,0,0,0,.6.05h.6V6.65a2.43,2.43,0,0,0-.6-.05ZM3,6.79a3,3,0,0,0-1.2.6v6.82a4.22,4.22,0,0,0,1.2.6ZM1.2,7.85a4.2,4.2,0,0,0,0,5.9Z"}));
}

Soundcloud.defaultProps = {"width":"30","height":"15","viewBox":"0 0 30 15"};

module.exports = Soundcloud;

Soundcloud.default = Soundcloud;
